// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4984a040","600":"1be3a7c2","879":"e24c3c6f","924":"89b0abd7","952":"c5b19377"}[chunkId] + ".chunk.js";
};